import React from 'react';
import { Button } from 'antd';
import OrderReturnForm from './OrderReturnForm';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { MdOutlineAssignmentReturn } from 'react-icons/md';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PageHeader from '@app/components/common/PageHeader/PageHeader';

const NewOrderReturn = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('id');

  const navigate = useNavigate();

  return (
    <>
      <PageHeader
        icon={<MdOutlineAssignmentReturn />}
        title="Tạo hoá đơn trả hàng"
        subtitle="Lập phiếu trả hàng từ đơn gốc"
        extra={
          <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
            Quay lại
          </Button>
        }
      />
      <OrderReturnForm tabKey="1" orderId={orderId} />
    </>
  );
};

export default NewOrderReturn;
